import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BackendService,
  HttpOptions,
  PaginatedResponseModel,
} from '@ipg/ngx-frontend-toolset';
import {
  User,
  UserCreateRequestModel,
  UserCreateResponseModel,
  UserUpdateRequestModel,
} from '../../../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly _backend = inject(BackendService);

  getList(options?: HttpOptions): Observable<PaginatedResponseModel<User[]>> {
    return this._backend.get('/user/list', options);
  }

  getById(userId: string): Observable<User> {
    return this._backend.get(`/user/${userId}`);
  }

  create(data: UserCreateRequestModel): Observable<UserCreateResponseModel> {
    return this._backend.post('/user', data);
  }

  update(userId: string, data: UserUpdateRequestModel) {
    return this._backend.put(`/user/${userId}`, data);
  }

  resetPassword(userId: string): Observable<UserCreateResponseModel> {
    return this._backend.put(`/user/${userId}/reset-password`, {});
  }

  delete(userId: string) {
    return this._backend.delete(`/user/${userId}`);
  }

  moveUser(userId: string, data: { targetUnitId: string }): Observable<void> {
    return this._backend.post(`/user/${userId}/move`, data);
  }
}
